import React from 'react';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../store/charts/chartsStore';
import { connect } from 'react-redux';
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import BbPopover from '../common/popover';
import ChartWarningsLegend from './chartWarningsLegend';
import classnames from 'classnames'
import { chartExportTypes } from '../../store/charts/exports/initial';

class ChartWarnings extends React.Component {
    render() {
        return (
            <div id="warningsContent">
                <div id="buttonsWarningList">
                    <div>
                        {this.renderExportButtonWithPover("Export (xlsx)", () => this.props.exportToXlsx(chartExportTypes.xlsxNi), chartExportTypes.xlsxNi)}
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th><Translate id="Charts.WarningTableSubjectName" /></th>
                            <th><Translate id="Charts.WarningTableSubjectIC" /></th>
                            <th><Translate id="Charts.WarningTableSubjectNegInfo" /></th>
                            <th><Translate id="Charts.WarningTableLevel" /></th>
                            <th><Translate id="Charts.WarningTableInRelationWith" /></th>
                            <th><Translate id="Charts.WarningTableRelation" /></th>
                        </tr>
                    </thead>
                    {this.props.bottomWindow.negInfo.data && <tbody className={classnames({ 'warn-profi': (this.props.topPanel || {}).isProfi === true })}>
                        {this.props.bottomWindow.negInfo.data.map(nd => this.renderNiData(nd))}
                    </tbody>}
                </table>
                <ChartWarningsLegend />
            </div>
        );
    }

    renderExportButtonWithPover = (title, onClickFunc, exportType) => {
        const exportUsed = this.props.exports.exportUsed.includes(exportType);
        return (
            <BbPopover
                content={this.props.translate('Common.Button.ExportPdf.Processing')}
                placement="right"
                targetId={`rc-warnings-export-button-${exportType}`}
                toggleOnEvent={exportUsed ? "toggleOnMouse" : "toggleNever"}
                withDelayAfterFirstToggle
            >
                {this.renderExportButton(title, onClickFunc, exportType)}
            </BbPopover>
        );
    }

    renderExportButton = (title, onClickFunc, exportType) => {
        const exportUsed = this.props.exports.exportUsed.includes(exportType);
        return (
            <a id={`rc-warnings-export-button-${exportType}`} className={classnames("rc-button-frame rc-button-text", { 'is-disabled': exportUsed })} style={{ textAlign: 'center' }} onClick={() => exportUsed ? undefined : onClickFunc()}>
                <span style={{ top: '0px', transform: 'none' }}>{title}</span>
            </a>
        );
    }

    renderNiData = (niData) => {
        const stl = { fontStyle: (niData.link !== null && niData.link.EndDate !== null) ? 'italic' : 'normal' };
        return (<tr key={niData.subject.EntityID}>
            <td style={stl}>{niData.subject.Name}</td>
            <td style={stl}>
                {niData.subject.Type === 'Person' && niData.subject.DateOfBirthOrCreationDateFormated}
                {niData.subject.Type === 'Address' && ''}
                {niData.subject.Type !== 'Address' && niData.subject.Type !== 'Person' && niData.subject.IC}
            </td>
            <td>{this._niRenderWarnings(niData.warnings).map(w => <span key={`${w.StatusID}|${w.WarningsCode}`} className={`warn-item warn-status-${w.StatusID}`}>{w.WarningsCode}</span>)}</td>
            <td style={stl}>{niData.subject.Level}</td>
            <td style={stl}>{niData.parent != null && niData.parent !== undefined ? niData.parent.Name : ''}</td>
            {niData.link !== null && <td style={stl}>{niData.link.Name + (niData.link.SharePct !== null ? (' (' + niData.link.SharePct + '%)') : '')}</td>}
            {niData.link === null && <td></td>}
        </tr>);
    }

    _niRenderWarnings(warnings) {
        var result = [];
        var observed = [];

        warnings.forEach(function (x) {
            var key = x.WarningsCode + '|' + x.StatusID;
            if (!observed.includes(key)) {
                result.push(x);
                observed.push(key);
            }
        });

        return result;
    }

    exportNi = () => {

    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartWarnings)));
